export default __webpack_public_path__ + "assets/zhejiang-ai-cultural-heritage-logo.963daa89.jpg";